import React from "react";
import { Link } from "react-router-dom";
import "./Login.css";

const Register = () => (
  <main className="login-page">
    <section className="login-showcase" aria-label="SPIN Management Portal access">
      <div className="login-showcase__glow login-showcase__glow--one" />
      <div className="login-showcase__glow login-showcase__glow--two" />
      <div className="login-brand"><span className="login-brand__mark"><img src="/payment-console-icon.svg" alt="" /></span><div><strong>SPIN Management Portal</strong><span>Unified Administration Workspace</span></div></div>
      <div className="login-showcase__content"><span className="login-showcase__eyebrow"><i className="fas fa-user-shield" /> CONTROLLED ACCESS</span><h1>Akses operasional yang aman dan terkelola.</h1><p>Akun administrator dibuat dan dikelola secara internal untuk melindungi data transaksi, merchant, dan pembayaran.</p></div>
      <p className="login-showcase__footer">Unified Administration Workspace</p>
    </section>
    <section className="login-form-section">
      <div className="login-form-mobile-brand"><span className="login-brand__mark"><img src="/payment-console-icon.svg" alt="" /></span><strong>SPIN Management Portal</strong></div>
      <div className="login-card">
        <div className="login-card__header"><span className="login-card__icon"><i className="fas fa-user-lock" /></span><h2>Pendaftaran dikelola admin</h2><p>Untuk keamanan, pembuatan akun baru tidak tersedia secara mandiri.</p></div>
        <div className="login-card__security-note"><i className="fas fa-info-circle" />Hubungi administrator sistem untuk meminta akses atau perubahan kewenangan akun.</div>
        <Link className="login-submit" to="/">Kembali ke halaman login <i className="fas fa-arrow-right" /></Link>
        <p className="login-card__help">Pastikan menggunakan email perusahaan yang telah terdaftar.</p>
      </div>
      <p className="login-form-section__copyright">&copy; {new Date().getFullYear()} SPIN Management Portal. All rights reserved.</p>
    </section>
  </main>
);

export default Register;
